import Tab from "../model/Tab";
import {EventBus} from "../events/event.bus";
import {EVENT_APP_NAVIGATE} from "../events/app.events";
import {useResultPageStore} from "../stores/ResultPageStore";
import PreviewManager from "./PreviewManager";
import ApiResponseHandler from "../handler/ApiResponseHandler";
import {satGlobals} from "../../../../../sat/helper/sat-globals";
import axios from 'axios';
import Analytics from "../util/Analytics";

class ToolManager {

    listener = false;

    constructor() {
    }

    async getTools() {
        Analytics.send('result_action', 'get_tools');

        this.store = useResultPageStore();
        let features = null;
        try {
            let response = await axios.get(satGlobals.getApiUrl('/api/content/features'), { withCredentials: true });
            features = response.data;
        } catch (err) {
        }

        this.store.resultPage.tools = features;
    }
}

export default new ToolManager()